import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { MatLegacyButtonModule as MatButtonModule } from "@angular/material/legacy-button";
import { MatToolbarModule } from "@angular/material/toolbar";
import { CoreModule } from "@obg/ngx.core";
import { CoreContentModule } from "@obg/ngx.core.content";
import { GlobalModule } from "@obg/ngx.global";
import { RouterModule } from "@obg/ngx.router";
import { CoreUiModule } from "@obg/ngx.ui.core";

import { NavbarContainer } from "./navbar.container";

const DIRECTIVES: any[] = [NavbarContainer];

@NgModule({
	imports: [
		CommonModule,
		GlobalModule,
		RouterModule,
		CoreModule,
		CoreContentModule,
		// todo: https://jirasson.betsson.local/browse/OBGB-8034 extract obgImageContent
		CoreUiModule,
		MatToolbarModule,
		MatButtonModule,
	],
	exports: DIRECTIVES,
	declarations: DIRECTIVES,
})
export class MatNavbarModule {}
